import api from './api';

/**
 * Flood Forecasting API Service
 * Interfaces with Google Flood Forecasting API via the backend
 */
export const floodApi = {
  /**
   * Get flood overview for a region (status + gauges + significant events)
   */
  getFloodOverview: async (regionCode = 'ZA') => {
    try {
      const response = await api.get('/floods/overview', { params: { regionCode } });
      return response.data;
    } catch (error) {
      console.error('Error fetching flood overview:', error);
      throw error;
    }
  },

  /**
   * Search flood status by region
   */
  getFloodStatus: async (regionCode = 'ZA', pageSize = 1000, includeNonQualityVerified = false) => {
    try {
      const response = await api.get('/floods/status', {
        params: { regionCode, pageSize, includeNonQualityVerified },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching flood status:', error);
      throw error;
    }
  },

  /**
   * Query flood status by gauge IDs
   */
  getFloodStatusByGauges: async (gaugeIds) => {
    try {
      const response = await api.post('/floods/status/by-gauges', { gaugeIds });
      return response.data;
    } catch (error) {
      console.error('Error querying flood status by gauges:', error);
      throw error;
    }
  },

  /**
   * Search gauges by region
   */
  getGauges: async (regionCode = 'ZA') => {
    try {
      const response = await api.get('/floods/gauges', { params: { regionCode } });
      return response.data;
    } catch (error) {
      console.error('Error fetching gauges:', error);
      throw error;
    }
  },

  /**
   * Get gauge model metadata (warning/danger thresholds)
   */
  getGaugeModels: async (gaugeIds) => {
    try {
      const response = await api.post('/floods/gauge-models', { gaugeIds });
      return response.data;
    } catch (error) {
      console.error('Error fetching gauge models:', error);
      throw error;
    }
  },

  /**
   * Get gauge forecasts for a time range
   */
  getGaugeForecasts: async (gaugeIds, startDate, endDate) => {
    try {
      const response = await api.post('/floods/forecasts', {
        gaugeIds,
        startDate,
        endDate,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching gauge forecasts:', error);
      throw error;
    }
  },

  /**
   * Get a serialized polygon (inundation/notification map)
   */
  getPolygon: async (polygonId) => {
    try {
      const response = await api.get(`/floods/polygon/${polygonId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching polygon:', error);
      throw error;
    }
  },

  /**
   * Get significant flood events globally
   */
  getSignificantEvents: async () => {
    try {
      const response = await api.get('/floods/significant-events');
      return response.data;
    } catch (error) {
      console.error('Error fetching significant events:', error);
      throw error;
    }
  },
};

export default floodApi;
